import { ProjectTargetResponseDto } from '../dto/response/project-target-response.dto';
import { ProjectTargetSaveRequestDto } from '../dto/request/project-target-save-request.dto';
import { ProjectTargetUpdateRequestDto } from '../dto/request/project-target-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class ProjectTargetService extends BaseLandscapeService {
  public async fetchProjectTargetById(
    id: string
  ): Promise<ProjectTargetResponseDto> {
    const response = await this.get<ProjectTargetResponseDto>(
      `/projecttarget/${id}`
    );
    return response.data;
  }

  public async fetchProjectTargetsByProjectId(
    projectId: string
  ): Promise<ProjectTargetResponseDto[]> {
    const response = await this.get<ProjectTargetResponseDto[]>(
      `/projecttarget/getprojecttargetsbyprojectid/${projectId}`
    );
    return response.data;
  }

  public async saveProjectTarget(
    saveRequest: ProjectTargetSaveRequestDto
  ): Promise<ProjectTargetResponseDto> {
    const response = await this.post<ProjectTargetResponseDto>(
      `/projecttarget`,
      saveRequest
    );
    return response.data;
  }

  public async updateProjectTarget(
    updateRequest: ProjectTargetUpdateRequestDto
  ): Promise<ProjectTargetResponseDto> {
    const response = await this.put<ProjectTargetResponseDto>(
      `/projecttarget`,
      updateRequest
    );
    return response.data;
  }

  public async deleteProjectTarget(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/projecttarget/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const projectTargetService = new ProjectTargetService();
export default projectTargetService;
